import React, { useEffect } from "react";

export default function PageAide() {
  return (
    <>
      <br />
      <br />
      <p>
        <b>
          <u>Créer un compte Metamask</u>
        </b>
        <br />
        <br />
        La première étape est de télécharger l’extension Metamask pour votre
        navigateur (https://metamask.io). Metamask est un portefeuille de
        crypto-monnaies (« crypto wallet »). <br />
        Metamask vous permet de créer un ou plusieurs comptes et signera ensuite
        vos transactions en les authentifiant.
        <br />
        <br />
        <br />
        <b>
          <u>Nous transmettre votre demande d'inscription</u>
        </b>
        <br />
        <br />
        Vous devrez ensuite nous communiquer (par email, à l'adresse
        contact@traceur-de-lots.eu) la clé publique correspondant à ce compte,
        afin que nous puissions l’alimenter en crypto-monnaie (toute transaction
        sur la blockchain, comme la création d’un lot, consomme de la
        crypto-monnaie).
        <br />
        <br />
        <br />
        <b>
          <u>Créer un Profil Fournisseur</u>
        </b>
        <br />
        <br />
        Le menu "Créer Fournisseur" vous permet de créer votre profil
        Fournisseur. Certaines informations (données de contact) ne figureront
        pas sur la Blockchain.
        <br />
        <br/>
        <br />
        <b>
          <u>Créer des lots</u>
        </b>
        <br />
        <br />
        Le menu "Créer Nouveau Lot" vous permet de créer un nouveau lot de
        fabrication et de générer le Qr-code correspondant. Vous indiquerez les
        ingrédients de vos propres fournisseurs entrant dans le contenu du
        produit. Si le lot du sous-traitant est déjà inscrit dans la Blockchain,
        la saisie en est alors facilitée et surtout le consommateur pourra
        remonter la chaîne de fabrication et voir ainsi une plus grande
        traçabilité.
        <br />
        Une note sur 100 caractérise le niveau de traçabilité et un classement indique
        le rang de ce lot parmi l'ensemble des lots connus par le système.
        <br />
        <br/>
        <br />
        <b>
          <u>Voir les lots</u>
        </b>
        <br />
        <br />
        Vous pouvez voir tous les lots dans la Blockchain en les désignant par leur numéro.
        Vous pouvez voir en particulier le dernier lot que vous avez créé.
        <br />
        Vous pouvez aussi visualiser toute la chaine de traçabilité d'un lot
        (c'est en réalité un graphe)
        <br />
        <br />
      </p>
    </>
  );
}
